// /var/www/speakiq/frontend/src/i18n/translations.js

export const translations = {
  en: {
    // Navigation - Tenant Admin
    nav_overview: 'Overview',
    nav_students: 'Students',
    nav_tutors: 'Tutors',
    nav_payments: 'Payments',
    nav_branding: 'Branding',
    nav_bookings: 'Bookings',
    nav_supply_demand: 'Supply & Demand',
    nav_marketing: 'Marketing',
    nav_settings: 'Settings',
    nav_pricing: 'Pricing',
    nav_certificates: 'Certificates',
    nav_website: 'Website',
    nav_registrations: 'Registrations',
    nav_logout: 'Logout',
    nav_partner_panel: 'Partner Panel',

    // Navigation - Student
    nav_dashboard: 'Dashboard',
    nav_my_lessons: 'My Lessons',
    nav_placement_test: 'Placement Test',
    nav_vocabulary: 'Vocabulary',
    nav_my_certificates: 'My Certificates',
    nav_book_tutor: 'Book a Tutor',
    nav_homework: 'Homework',
    nav_my_id: 'My ID Card',
    nav_payment_settings: 'Payment Settings',
    nav_payouts: 'Payouts',
    nav_programmes: 'Programmes',

    // Navigation - Tutor
    nav_my_students: 'My Students',
    nav_earnings: 'My Earnings',
    nav_availability: 'Availability',
    nav_my_id_card: 'My ID Card',

    // Common buttons
    btn_save: 'Save',
    btn_cancel: 'Cancel',
    btn_submit: 'Submit',
    btn_delete: 'Delete',
    btn_edit: 'Edit',
    btn_add: 'Add',
    btn_search: 'Search',
    btn_filter: 'Filter',
    btn_export: 'Export',
    btn_back: 'Back',
    btn_next: 'Next',
    btn_previous: 'Previous',
    btn_confirm: 'Confirm',
    btn_close: 'Close',
    btn_upload: 'Upload',
    btn_download: 'Download',
    btn_approve: 'Approve',
    btn_decline: 'Decline',
    btn_view: 'View',
    btn_apply: 'Apply',
    btn_login: 'Login',
    btn_register: 'Register',
    btn_logout: 'Logout',
    btn_send: 'Send',
    btn_start: 'Start',
    btn_finish: 'Finish',
    btn_continue: 'Continue',
    btn_try_again: 'Try Again',
    btn_get_started: 'Get Started',
    btn_learn_more: 'Learn More',

    // Status
    status_active: 'Active',
    status_inactive: 'Inactive',
    status_pending: 'Pending',
    status_approved: 'Approved',
    status_declined: 'Declined',
    status_suspended: 'Suspended',
    status_trial: 'Trial',
    status_loading: 'Loading...',
    status_error: 'Something went wrong',
    status_success: 'Success',
    status_no_data: 'No data found',
    status_saved: 'Saved!',

    // Login page
    login_title: 'Welcome Back',
    login_subtitle: 'Sign in to your account',
    login_email: 'Email Address',
    login_password: 'Password',
    login_forgot: 'Forgot password?',
    login_no_account: "Don't have an account?",
    login_sign_up: 'Sign up',
    login_error: 'Invalid email or password',
    login_loading: 'Signing in...',
    login_partner_title: 'Partner Admin Portal',
    login_student_title: 'Student Portal',
    login_tutor_title: 'Tutor Portal',
    login_apply_tutor: 'Apply to Teach \u2192',

    // Register page
    register_title: 'Create Account',
    register_first_name: 'First Name',
    register_last_name: 'Last Name',
    register_email: 'Email Address',
    register_password: 'Password',
    register_confirm_password: 'Confirm Password',
    register_phone: 'Phone Number',
    register_submit: 'Create Account',
    register_have_account: 'Already have an account?',
    register_sign_in: 'Sign in',
    register_success: 'Account created! Please check your email.',
    register_error_match: 'Passwords do not match',
    register_error_exists: 'Email already registered',

    // Student Dashboard
    dash_welcome: 'Welcome back',
    dash_current_level: 'Current Level',
    dash_lessons_completed: 'Lessons Completed',
    dash_avg_score: 'Average Score',
    dash_streak: 'Day Streak',
    dash_continue_learning: 'Continue Learning',
    dash_recent_activity: 'Recent Activity',
    dash_my_progress: 'My Progress',
    dash_upcoming: 'Upcoming',
    dash_achievements: 'Achievements',
    dash_start_lesson: 'Start Lesson',
    dash_take_test: 'Take Placement Test',
    dash_no_level: 'No level assigned yet',
    dash_complete_placement: 'Complete your placement test to get started',

    // Lesson page
    lesson_title: 'Lesson',
    lesson_question: 'Question',
    lesson_of: 'of',
    lesson_check: 'Check Answer',
    lesson_next: 'Next Question',
    lesson_correct: 'Correct!',
    lesson_incorrect: 'Incorrect',
    lesson_complete: 'Lesson Complete!',
    lesson_score: 'Your Score',
    lesson_ask_question: 'Ask a question about this lesson',
    lesson_type_question: 'Type your question here...',
    lesson_grammar: 'Grammar',
    lesson_vocabulary: 'Vocabulary',
    lesson_reading: 'Reading',
    lesson_writing: 'Writing',
    lesson_conversation: 'Conversation',
    lesson_ielts: 'IELTS Prep',
    lesson_business: 'Business English',
    lesson_questions_remaining: 'free questions remaining',
    lesson_well_done: 'Well done!',
    lesson_keep_going: 'Keep going!',
    lesson_try_harder: 'Keep practising!',

    // Placement test
    placement_title: 'English Placement Test',
    placement_subtitle: 'We will find your level',
    placement_start: 'Start Test',
    placement_question: 'Question',
    placement_complete: 'Test Complete',
    placement_your_level: 'Your English Level',
    placement_result_msg: 'Based on your answers, your level is',
    placement_retake: 'Retake Test',

    // Vocabulary
    vocab_title: 'Vocabulary Bank',
    vocab_search: 'Search words...',
    vocab_add: 'Add Word',
    vocab_word: 'Word',
    vocab_definition: 'Definition',
    vocab_example: 'Example',
    vocab_level: 'Level',
    vocab_empty: 'No words saved yet',
    vocab_add_first: 'Start adding vocabulary from your lessons',

    // Certificates
    cert_title: 'My Certificates',
    cert_level: 'Level',
    cert_issued: 'Issued',
    cert_download: 'Download PDF',
    cert_verify: 'Verify',
    cert_empty: 'No certificates yet',
    cert_complete_msg: 'Complete a level to earn your certificate',
    cert_achievement: 'Certificate of Achievement',

    // Book a tutor
    book_title: 'Book a Tutor',
    book_select_tutor: 'Select a Tutor',
    book_select_time: 'Select Time',
    book_confirm: 'Confirm Booking',
    book_success: 'Booking confirmed!',
    book_no_tutors: 'No tutors available',
    book_specialization: 'Specialization',
    book_rate: 'Rate',
    book_per_hour: 'per hour',
    book_available: 'Available',

    // Homework
    hw_title: 'Homework',
    hw_due: 'Due',
    hw_submit: 'Submit Homework',
    hw_submitted: 'Submitted',
    hw_pending: 'Pending',
    hw_overdue: 'Overdue',
    hw_grade: 'Grade',
    hw_feedback: 'Feedback',
    hw_empty: 'No homework assigned',
    hw_instructions: 'Instructions',
    hw_your_answer: 'Your Answer',
    hw_word_count: 'words',

    // ID Card
    id_title: 'My ID Card',
    id_student: 'Student',
    id_level: 'Level',
    id_enrolled: 'Enrolled',
    id_school: 'School',
    id_valid: 'Valid Until',
    id_scan: 'Scan to verify',
    id_pending: 'ID card pending approval',

    // Admin - Overview
    admin_total_students: 'Total Students',
    admin_active_tutors: 'Active Tutors',
    admin_lessons_this_month: 'Lessons This Month',
    admin_revenue: 'Revenue',
    admin_recent_registrations: 'Recent Registrations',
    admin_pending_applications: 'Pending Applications',
    admin_quick_actions: 'Quick Actions',

    // Admin - Students
    admin_students_title: 'Students',
    admin_student_name: 'Name',
    admin_student_email: 'Email',
    admin_student_level: 'Level',
    admin_student_joined: 'Joined',
    admin_student_status: 'Status',
    admin_student_lessons: 'Lessons',
    admin_student_search: 'Search students...',

    // Admin - Tutors
    admin_tutors_title: 'Tutors',
    admin_tutor_applications: 'Applications',
    admin_tutor_active: 'Active Tutors',
    admin_tutor_declined: 'Declined',
    admin_tutor_approve: 'Approve',
    admin_tutor_decline: 'Decline',
    admin_tutor_bio: 'Bio',
    admin_tutor_specializations: 'Specializations',
    admin_tutor_applied: 'Applied',
    admin_tutor_no_applications: 'No pending applications',
    admin_tutor_no_active: 'No active tutors yet',
    admin_decline_reason: 'Reason for declining (optional)',
    admin_decline_placeholder: 'Enter reason...',

    // Admin - Settings
    admin_settings_title: 'School Settings',
    admin_school_name: 'School Name',
    admin_school_email: 'Contact Email',
    admin_school_phone: 'Phone Number',
    admin_school_address: 'Address',
    admin_school_city: 'City',
    admin_school_country: 'Country',
    admin_features: 'Features',
    admin_feature_ai: 'AI Tutor',
    admin_feature_homework: 'Homework',
    admin_feature_certificates: 'Certificates',
    admin_feature_booking: 'Tutor Booking',
    admin_save_settings: 'Save Settings',
    admin_settings_saved: 'Settings saved successfully',

    // Admin - Certificates
    admin_cert_title: 'Certificates',
    admin_cert_issue: 'Issue Certificate',
    admin_cert_student: 'Student',
    admin_cert_level: 'Level',
    admin_cert_date: 'Issue Date',
    admin_cert_actions: 'Actions',

    // Tutor portal
    tutor_welcome: 'Welcome',
    tutor_my_students: 'My Students',
    tutor_sessions_today: 'Sessions Today',
    tutor_total_sessions: 'Total Sessions',
    tutor_rating: 'Rating',
    tutor_earnings_title: 'My Earnings',
    tutor_total_earned: 'Total Earned',
    tutor_this_month: 'This Month',
    tutor_pending_payout: 'Pending Payout',
    tutor_payout_history: 'Payout History',
    tutor_availability_title: 'My Availability',
    tutor_set_hours: 'Set Available Hours',
    tutor_id_card: 'My ID Card',
    tutor_id_number: 'Tutor ID',
    tutor_approved: 'Approved',
    tutor_specializations: 'Specializations',
    tutor_id_pending: 'Your ID card will be ready after approval',

    // Tutor application
    apply_title: 'Apply to Teach',
    apply_step1: 'Personal Details',
    apply_step2: 'Work Experience',
    apply_step3: 'Education',
    apply_step4: 'Review',
    apply_first_name: 'First Name',
    apply_last_name: 'Last Name',
    apply_email: 'Email',
    apply_password: 'Password',
    apply_phone: 'Phone Number',
    apply_dob: 'Date of Birth',
    apply_nationality: 'Nationality',
    apply_native_lang: 'Native Language',
    apply_specializations: 'Specializations',
    apply_bio: 'About You',
    apply_bio_placeholder: 'Tell us about yourself and your teaching experience...',
    apply_photo: 'Profile Photo',
    apply_add_experience: '+ Add Experience',
    apply_job_title: 'Job Title',
    apply_company: 'Company / School',
    apply_start_date: 'Start Date',
    apply_end_date: 'End Date',
    apply_current: 'Currently working here',
    apply_description: 'Description',
    apply_degree: 'Degree',
    apply_institution: 'Institution',
    apply_year: 'Year',
    apply_certs: 'Teaching Certifications',
    apply_qual_upload: 'Upload Proof of Qualification',
    apply_cv_upload: 'Upload CV (optional)',
    apply_submit: 'Submit Application',
    apply_success_title: 'Application Submitted!',
    apply_success_msg: 'We will review your application and contact you within 3-5 business days.',

    // School homepage (public)
    school_hero_subtitle: 'Learn English with expert tutors and AI-powered lessons',
    school_enroll_now: 'Enroll Now',
    school_learn_more: 'Learn More',
    school_our_courses: 'Our Courses',
    school_all_levels: 'All Levels',
    school_beginner: 'Beginner',
    school_intermediate: 'Intermediate',
    school_advanced: 'Advanced',
    school_our_tutors: 'Our Tutors',
    school_contact: 'Contact Us',
    school_location: 'Location',
    school_phone: 'Phone',
    school_email: 'Email',
    school_get_in_touch: 'Get in Touch',
    school_your_name: 'Your Name',
    school_your_email: 'Your Email',
    school_your_message: 'Your Message',
    school_send_message: 'Send Message',
    school_login_student: 'Student Login',
    school_login_tutor: 'Tutor Login',
    school_apply_tutor: 'Apply as Tutor',
    school_powered_by: 'Powered by SpeakIQ',
    school_why_us: 'Why Choose Us?',
    school_ai_powered: 'AI-Powered Learning',
    school_ai_desc: 'Personalised lessons adapted to your level',
    school_expert_tutors: 'Expert Tutors',
    school_tutors_desc: 'Qualified teachers with years of experience',
    school_certificates: 'Certificates',
    school_cert_desc: 'Earn internationally recognised CEFR certificates',
    school_flexible: 'Flexible Schedule',
    school_flex_desc: 'Learn at your own pace, anytime',

    // Level names
    level_a1: 'Beginner (A1)',
    level_a2: 'Elementary (A2)',
    level_b1: 'Intermediate (B1)',
    level_b2: 'Upper Intermediate (B2)',
    level_c1: 'Advanced (C1)',
    level_c2: 'Proficient (C2)',

    // Errors
    err_required: 'This field is required',
    err_invalid_email: 'Invalid email address',
    err_server: 'Server error. Please try again.',
    err_network: 'Network error. Check your connection.',
    err_unauthorized: 'You are not authorized to view this page',
    err_not_found: 'Page not found',

    // Payment system
    pay_title: 'Course Payment',
    pay_pending: 'Payment Required',
    pay_pending_desc: 'To access your course, please make a bank transfer to the details below and upload your proof of payment.',
    pay_submitted: 'Awaiting Confirmation',
    pay_submitted_desc: 'Your payment proof has been received. We will confirm your payment shortly.',
    pay_confirmed: 'Payment Confirmed',
    pay_confirmed_desc: 'Your course is now unlocked. Welcome!',
    pay_bank_name: 'Bank Name',
    pay_account_holder: 'Account Holder',
    pay_account_number: 'Account Number',
    pay_sort_code: 'Sort Code',
    pay_swift: 'SWIFT / BIC',
    pay_paypal: 'PayPal Email',
    pay_wise: 'Wise Email',
    pay_notes: 'Payment Notes',
    pay_upload_proof: 'Upload Payment Proof',
    pay_uploading: 'Uploading...',
    pay_upload_done: 'Proof Uploaded',
    // Greetings
    dash_good_morning: 'Good morning',
    dash_good_afternoon: 'Good afternoon',
    dash_good_evening: 'Good evening',
  },

  ru: {
    nav_overview: '\u041e\u0431\u0437\u043e\u0440',
    nav_students: '\u0421\u0442\u0443\u0434\u0435\u043d\u0442\u044b',
    nav_tutors: '\u041f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u0438',
    nav_payments: '\u041f\u043b\u0430\u0442\u0435\u0436\u0438',
    nav_branding: '\u0411\u0440\u0435\u043d\u0434\u0438\u043d\u0433',
    nav_bookings: '\u0411\u0440\u043e\u043d\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u044f',
    nav_supply_demand: '\u0421\u043f\u0440\u043e\u0441 \u0438 \u043f\u0440\u0435\u0434\u043b\u043e\u0436\u0435\u043d\u0438\u0435',
    nav_marketing: '\u041c\u0430\u0440\u043a\u0435\u0442\u0438\u043d\u0433',
    nav_settings: '\u041d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438',
    nav_pricing: '\u0422\u0430\u0440\u0438\u0444\u044b',
    nav_certificates: '\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u044b',
    nav_website: '\u0412\u0435\u0431\u0441\u0430\u0439\u0442',
    nav_registrations: '\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438',
    nav_logout: '\u0412\u044b\u0439\u0442\u0438',
    nav_partner_panel: '\u041f\u0430\u043d\u0435\u043b\u044c \u043f\u0430\u0440\u0442\u043d\u0451\u0440\u0430',
    nav_dashboard: '\u0413\u043b\u0430\u0432\u043d\u0430\u044f',
    nav_my_lessons: '\u041c\u043e\u0438 \u0443\u0440\u043e\u043a\u0438',
    nav_placement_test: '\u0422\u0435\u0441\u0442 \u043d\u0430 \u0443\u0440\u043e\u0432\u0435\u043d\u044c',
    nav_vocabulary: '\u0421\u043b\u043e\u0432\u0430\u0440\u044c',
    nav_my_certificates: '\u041c\u043e\u0438 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u044b',
    nav_book_tutor: '\u0417\u0430\u043f\u0438\u0441\u0430\u0442\u044c\u0441\u044f \u043a \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u044e',
    nav_homework: '\u0414\u043e\u043c\u0430\u0448\u043d\u0435\u0435 \u0437\u0430\u0434\u0430\u043d\u0438\u0435',
    nav_my_id: '\u041c\u043e\u044f \u043a\u0430\u0440\u0442\u043e\u0447\u043a\u0430',
    nav_payment_settings: 'Настройки оплаты',
    nav_payouts: 'Выплаты',
    nav_programmes: '\u041f\u0440\u043e\u0433\u0440\u0430\u043c\u043c\u044b',
    nav_my_students: '\u041c\u043e\u0438 \u0441\u0442\u0443\u0434\u0435\u043d\u0442\u044b',
    nav_earnings: '\u041c\u043e\u0439 \u0434\u043e\u0445\u043e\u0434',
    nav_availability: '\u0420\u0430\u0441\u043f\u0438\u0441\u0430\u043d\u0438\u0435',
    nav_my_id_card: '\u041c\u043e\u044f \u043a\u0430\u0440\u0442\u043e\u0447\u043a\u0430',
    btn_save: '\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c',
    btn_cancel: '\u041e\u0442\u043c\u0435\u043d\u0430',
    btn_submit: '\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c',
    btn_delete: '\u0423\u0434\u0430\u043b\u0438\u0442\u044c',
    btn_edit: '\u0420\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u0442\u044c',
    btn_add: '\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c',
    btn_search: '\u041f\u043e\u0438\u0441\u043a',
    btn_filter: '\u0424\u0438\u043b\u044c\u0442\u0440',
    btn_export: '\u042d\u043a\u0441\u043f\u043e\u0440\u0442',
    btn_back: '\u041d\u0430\u0437\u0430\u0434',
    btn_next: '\u0414\u0430\u043b\u0435\u0435',
    btn_previous: '\u041d\u0430\u0437\u0430\u0434',
    btn_confirm: '\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c',
    btn_close: '\u0417\u0430\u043a\u0440\u044b\u0442\u044c',
    btn_upload: '\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c',
    btn_download: '\u0421\u043a\u0430\u0447\u0430\u0442\u044c',
    btn_approve: '\u041e\u0434\u043e\u0431\u0440\u0438\u0442\u044c',
    btn_decline: '\u041e\u0442\u043a\u043b\u043e\u043d\u0438\u0442\u044c',
    btn_view: '\u041f\u0440\u043e\u0441\u043c\u043e\u0442\u0440',
    btn_apply: '\u041f\u043e\u0434\u0430\u0442\u044c \u0437\u0430\u044f\u0432\u043a\u0443',
    btn_login: '\u0412\u043e\u0439\u0442\u0438',
    btn_register: '\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u0442\u044c\u0441\u044f',
    btn_logout: '\u0412\u044b\u0439\u0442\u0438',
    btn_send: '\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c',
    btn_start: '\u041d\u0430\u0447\u0430\u0442\u044c',
    btn_finish: '\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044c',
    btn_continue: '\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u044c',
    btn_try_again: '\u041f\u043e\u043f\u0440\u043e\u0431\u043e\u0432\u0430\u0442\u044c \u0441\u043d\u043e\u0432\u0430',
    btn_get_started: '\u041d\u0430\u0447\u0430\u0442\u044c',
    btn_learn_more: '\u0423\u0437\u043d\u0430\u0442\u044c \u0431\u043e\u043b\u044c\u0448\u0435',
    status_active: '\u0410\u043a\u0442\u0438\u0432\u043d\u044b\u0439',
    status_inactive: '\u041d\u0435\u0430\u043a\u0442\u0438\u0432\u043d\u044b\u0439',
    status_pending: '\u041d\u0430 \u0440\u0430\u0441\u0441\u043c\u043e\u0442\u0440\u0435\u043d\u0438\u0438',
    status_approved: '\u041e\u0434\u043e\u0431\u0440\u0435\u043d\u043e',
    status_declined: '\u041e\u0442\u043a\u043b\u043e\u043d\u0435\u043d\u043e',
    status_suspended: '\u041f\u0440\u0438\u043e\u0441\u0442\u0430\u043d\u043e\u0432\u043b\u0435\u043d',
    status_trial: '\u041f\u0440\u043e\u0431\u043d\u044b\u0439',
    status_loading: '\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430...',
    status_error: '\u0427\u0442\u043e-\u0442\u043e \u043f\u043e\u0448\u043b\u043e \u043d\u0435 \u0442\u0430\u043a',
    status_success: '\u0423\u0441\u043f\u0435\u0448\u043d\u043e',
    status_no_data: '\u0414\u0430\u043d\u043d\u044b\u0435 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u044b',
    status_saved: '\u0421\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043e!',
    login_title: '\u0421 \u0432\u043e\u0437\u0432\u0440\u0430\u0449\u0435\u043d\u0438\u0435\u043c',
    login_subtitle: '\u0412\u043e\u0439\u0434\u0438\u0442\u0435 \u0432 \u0441\u0432\u043e\u0439 \u0430\u043a\u043a\u0430\u0443\u043d\u0442',
    login_email: '\u042d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0430\u044f \u043f\u043e\u0447\u0442\u0430',
    login_password: '\u041f\u0430\u0440\u043e\u043b\u044c',
    login_forgot: '\u0417\u0430\u0431\u044b\u043b\u0438 \u043f\u0430\u0440\u043e\u043b\u044c?',
    login_no_account: '\u041d\u0435\u0442 \u0430\u043a\u043a\u0430\u0443\u043d\u0442\u0430?',
    login_sign_up: '\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u0442\u044c\u0441\u044f',
    login_error: '\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 email \u0438\u043b\u0438 \u043f\u0430\u0440\u043e\u043b\u044c',
    login_loading: '\u0412\u044b\u043f\u043e\u043b\u043d\u044f\u0435\u0442\u0441\u044f \u0432\u0445\u043e\u0434...',
    login_partner_title: '\u041f\u043e\u0440\u0442\u0430\u043b \u0430\u0434\u043c\u0438\u043d\u0438\u0441\u0442\u0440\u0430\u0442\u043e\u0440\u0430',
    login_student_title: '\u041f\u043e\u0440\u0442\u0430\u043b \u0441\u0442\u0443\u0434\u0435\u043d\u0442\u0430',
    login_tutor_title: '\u041f\u043e\u0440\u0442\u0430\u043b \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u044f',
    login_apply_tutor: '\u0421\u0442\u0430\u0442\u044c \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u0435\u043c \u2192',
    register_title: '\u0421\u043e\u0437\u0434\u0430\u0442\u044c \u0430\u043a\u043a\u0430\u0443\u043d\u0442',
    register_first_name: '\u0418\u043c\u044f',
    register_last_name: '\u0424\u0430\u043c\u0438\u043b\u0438\u044f',
    register_email: '\u042d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0430\u044f \u043f\u043e\u0447\u0442\u0430',
    register_password: '\u041f\u0430\u0440\u043e\u043b\u044c',
    register_confirm_password: '\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043f\u0430\u0440\u043e\u043b\u044c',
    register_phone: '\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430',
    register_submit: '\u0421\u043e\u0437\u0434\u0430\u0442\u044c \u0430\u043a\u043a\u0430\u0443\u043d\u0442',
    register_have_account: '\u0423\u0436\u0435 \u0435\u0441\u0442\u044c \u0430\u043a\u043a\u0430\u0443\u043d\u0442?',
    register_sign_in: '\u0412\u043e\u0439\u0442\u0438',
    register_success: '\u0410\u043a\u043a\u0430\u0443\u043d\u0442 \u0441\u043e\u0437\u0434\u0430\u043d! \u041f\u0440\u043e\u0432\u0435\u0440\u044c\u0442\u0435 \u0432\u0430\u0448\u0443 \u043f\u043e\u0447\u0442\u0443.',
    register_error_match: '\u041f\u0430\u0440\u043e\u043b\u0438 \u043d\u0435 \u0441\u043e\u0432\u043f\u0430\u0434\u0430\u044e\u0442',
    register_error_exists: 'Email \u0443\u0436\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u043d',
    dash_welcome: '\u0421 \u0432\u043e\u0437\u0432\u0440\u0430\u0449\u0435\u043d\u0438\u0435\u043c',
    dash_current_level: '\u0422\u0435\u043a\u0443\u0449\u0438\u0439 \u0443\u0440\u043e\u0432\u0435\u043d\u044c',
    dash_lessons_completed: '\u0423\u0440\u043e\u043a\u043e\u0432 \u043f\u0440\u043e\u0439\u0434\u0435\u043d\u043e',
    dash_avg_score: '\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u0431\u0430\u043b\u043b',
    dash_streak: '\u0434\u043d\u0435\u0439 \u043f\u043e\u0434\u0440\u044f\u0434',
    dash_continue_learning: '\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u044c \u043e\u0431\u0443\u0447\u0435\u043d\u0438\u0435',
    dash_recent_activity: '\u041f\u043e\u0441\u043b\u0435\u0434\u043d\u044f\u044f \u0430\u043a\u0442\u0438\u0432\u043d\u043e\u0441\u0442\u044c',
    dash_my_progress: '\u041c\u043e\u0439 \u043f\u0440\u043e\u0433\u0440\u0435\u0441\u0441',
    dash_upcoming: '\u041f\u0440\u0435\u0434\u0441\u0442\u043e\u044f\u0449\u0438\u0435',
    dash_achievements: '\u0414\u043e\u0441\u0442\u0438\u0436\u0435\u043d\u0438\u044f',
    dash_start_lesson: '\u041d\u0430\u0447\u0430\u0442\u044c \u0443\u0440\u043e\u043a',
    dash_take_test: '\u041f\u0440\u043e\u0439\u0442\u0438 \u0442\u0435\u0441\u0442 \u043d\u0430 \u0443\u0440\u043e\u0432\u0435\u043d\u044c',
    dash_no_level: '\u0423\u0440\u043e\u0432\u0435\u043d\u044c \u0435\u0449\u0451 \u043d\u0435 \u043e\u043f\u0440\u0435\u0434\u0435\u043b\u0451\u043d',
    dash_complete_placement: '\u041f\u0440\u043e\u0439\u0434\u0438\u0442\u0435 \u0442\u0435\u0441\u0442 \u043d\u0430 \u0443\u0440\u043e\u0432\u0435\u043d\u044c, \u0447\u0442\u043e\u0431\u044b \u043d\u0430\u0447\u0430\u0442\u044c',
    lesson_title: '\u0423\u0440\u043e\u043a',
    lesson_question: '\u0412\u043e\u043f\u0440\u043e\u0441',
    lesson_of: '\u0438\u0437',
    lesson_check: '\u041f\u0440\u043e\u0432\u0435\u0440\u0438\u0442\u044c \u043e\u0442\u0432\u0435\u0442',
    lesson_next: '\u0421\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439 \u0432\u043e\u043f\u0440\u043e\u0441',
    lesson_correct: '\u041f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u043e!',
    lesson_incorrect: '\u041d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u043e',
    lesson_complete: '\u0423\u0440\u043e\u043a \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043d!',
    lesson_score: '\u0412\u0430\u0448 \u0440\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442',
    lesson_ask_question: '\u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u0432\u043e\u043f\u0440\u043e\u0441 \u043f\u043e \u0443\u0440\u043e\u043a\u0443',
    lesson_type_question: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448 \u0432\u043e\u043f\u0440\u043e\u0441...',
    lesson_grammar: '\u0413\u0440\u0430\u043c\u043c\u0430\u0442\u0438\u043a\u0430',
    lesson_vocabulary: '\u0421\u043b\u043e\u0432\u0430\u0440\u043d\u044b\u0439 \u0437\u0430\u043f\u0430\u0441',
    lesson_reading: '\u0427\u0442\u0435\u043d\u0438\u0435',
    lesson_writing: '\u041f\u0438\u0441\u044c\u043c\u043e',
    lesson_conversation: '\u0420\u0430\u0437\u0433\u043e\u0432\u043e\u0440\u043d\u0430\u044f \u0440\u0435\u0447\u044c',
    lesson_ielts: '\u041f\u043e\u0434\u0433\u043e\u0442\u043e\u0432\u043a\u0430 \u043a IELTS',
    lesson_business: '\u0414\u0435\u043b\u043e\u0432\u043e\u0439 \u0430\u043d\u0433\u043b\u0438\u0439\u0441\u043a\u0438\u0439',
    lesson_questions_remaining: '\u0431\u0435\u0441\u043f\u043b\u0430\u0442\u043d\u044b\u0445 \u0432\u043e\u043f\u0440\u043e\u0441\u043e\u0432 \u043e\u0441\u0442\u0430\u043b\u043e\u0441\u044c',
    lesson_well_done: '\u041e\u0442\u043b\u0438\u0447\u043d\u043e!',
    lesson_keep_going: '\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0430\u0439\u0442\u0435!',
    lesson_try_harder: '\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0430\u0439\u0442\u0435 \u043f\u0440\u0430\u043a\u0442\u0438\u043a\u043e\u0432\u0430\u0442\u044c\u0441\u044f!',
    placement_title: '\u0422\u0435\u0441\u0442 \u043d\u0430 \u0443\u0440\u043e\u0432\u0435\u043d\u044c \u0430\u043d\u0433\u043b\u0438\u0439\u0441\u043a\u043e\u0433\u043e',
    placement_subtitle: '\u041c\u044b \u043e\u043f\u0440\u0435\u0434\u0435\u043b\u0438\u043c \u0432\u0430\u0448 \u0443\u0440\u043e\u0432\u0435\u043d\u044c',
    placement_start: '\u041d\u0430\u0447\u0430\u0442\u044c \u0442\u0435\u0441\u0442',
    placement_question: '\u0412\u043e\u043f\u0440\u043e\u0441',
    placement_complete: '\u0422\u0435\u0441\u0442 \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043d',
    placement_your_level: '\u0412\u0430\u0448 \u0443\u0440\u043e\u0432\u0435\u043d\u044c \u0430\u043d\u0433\u043b\u0438\u0439\u0441\u043a\u043e\u0433\u043e',
    placement_result_msg: '\u041f\u043e \u0440\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u0430\u043c \u0432\u0430\u0448\u0438\u0445 \u043e\u0442\u0432\u0435\u0442\u043e\u0432, \u0432\u0430\u0448 \u0443\u0440\u043e\u0432\u0435\u043d\u044c',
    placement_retake: '\u041f\u0440\u043e\u0439\u0442\u0438 \u0441\u043d\u043e\u0432\u0430',
    vocab_title: '\u0421\u043b\u043e\u0432\u0430\u0440\u043d\u044b\u0439 \u0431\u0430\u043d\u043a',
    vocab_search: '\u041f\u043e\u0438\u0441\u043a \u0441\u043b\u043e\u0432...',
    vocab_add: '\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0441\u043b\u043e\u0432\u043e',
    vocab_word: '\u0421\u043b\u043e\u0432\u043e',
    vocab_definition: '\u041e\u043f\u0440\u0435\u0434\u0435\u043b\u0435\u043d\u0438\u0435',
    vocab_example: '\u041f\u0440\u0438\u043c\u0435\u0440',
    vocab_level: '\u0423\u0440\u043e\u0432\u0435\u043d\u044c',
    vocab_empty: '\u0421\u043b\u043e\u0432\u0430 \u0435\u0449\u0451 \u043d\u0435 \u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u044b',
    vocab_add_first: '\u041d\u0430\u0447\u043d\u0438\u0442\u0435 \u0434\u043e\u0431\u0430\u0432\u043b\u044f\u0442\u044c \u0441\u043b\u043e\u0432\u0430 \u0438\u0437 \u0443\u0440\u043e\u043a\u043e\u0432',
    cert_title: '\u041c\u043e\u0438 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u044b',
    cert_level: '\u0423\u0440\u043e\u0432\u0435\u043d\u044c',
    cert_issued: '\u0412\u044b\u0434\u0430\u043d',
    cert_download: '\u0421\u043a\u0430\u0447\u0430\u0442\u044c PDF',
    cert_verify: '\u041f\u0440\u043e\u0432\u0435\u0440\u0438\u0442\u044c',
    cert_empty: '\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u043e\u0432 \u043f\u043e\u043a\u0430 \u043d\u0435\u0442',
    cert_complete_msg: '\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0435 \u0443\u0440\u043e\u0432\u0435\u043d\u044c, \u0447\u0442\u043e\u0431\u044b \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442',
    cert_achievement: '\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442 \u043e\u0431 \u043e\u043a\u043e\u043d\u0447\u0430\u043d\u0438\u0438',
    book_title: '\u0417\u0430\u043f\u0438\u0441\u0430\u0442\u044c\u0441\u044f \u043a \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u044e',
    book_select_tutor: '\u0412\u044b\u0431\u0440\u0430\u0442\u044c \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u044f',
    book_select_time: '\u0412\u044b\u0431\u0440\u0430\u0442\u044c \u0432\u0440\u0435\u043c\u044f',
    book_confirm: '\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u0437\u0430\u043f\u0438\u0441\u044c',
    book_success: '\u0417\u0430\u043f\u0438\u0441\u044c \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0430!',
    book_no_tutors: '\u041f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u0438 \u043d\u0435\u0434\u043e\u0441\u0442\u0443\u043f\u043d\u044b',
    book_specialization: '\u0421\u043f\u0435\u0446\u0438\u0430\u043b\u0438\u0437\u0430\u0446\u0438\u044f',
    book_rate: '\u0421\u0442\u043e\u0438\u043c\u043e\u0441\u0442\u044c',
    book_per_hour: '\u0432 \u0447\u0430\u0441',
    book_available: '\u0414\u043e\u0441\u0442\u0443\u043f\u0435\u043d',
    hw_title: '\u0414\u043e\u043c\u0430\u0448\u043d\u0435\u0435 \u0437\u0430\u0434\u0430\u043d\u0438\u0435',
    hw_due: '\u0421\u0440\u043e\u043a',
    hw_submit: '\u0421\u0434\u0430\u0442\u044c \u0437\u0430\u0434\u0430\u043d\u0438\u0435',
    hw_submitted: '\u0421\u0434\u0430\u043d\u043e',
    hw_pending: '\u041e\u0436\u0438\u0434\u0430\u0435\u0442',
    hw_overdue: '\u041f\u0440\u043e\u0441\u0440\u043e\u0447\u0435\u043d\u043e',
    hw_grade: '\u041e\u0446\u0435\u043d\u043a\u0430',
    hw_feedback: '\u041e\u0431\u0440\u0430\u0442\u043d\u0430\u044f \u0441\u0432\u044f\u0437\u044c',
    hw_empty: '\u0414\u043e\u043c\u0430\u0448\u043d\u0438\u0445 \u0437\u0430\u0434\u0430\u043d\u0438\u0439 \u043d\u0435\u0442',
    hw_instructions: '\u0418\u043d\u0441\u0442\u0440\u0443\u043a\u0446\u0438\u0438',
    hw_your_answer: '\u0412\u0430\u0448 \u043e\u0442\u0432\u0435\u0442',
    hw_word_count: '\u0441\u043b\u043e\u0432',
    id_title: '\u041c\u043e\u044f \u043a\u0430\u0440\u0442\u043e\u0447\u043a\u0430',
    id_student: '\u0421\u0442\u0443\u0434\u0435\u043d\u0442',
    id_level: '\u0423\u0440\u043e\u0432\u0435\u043d\u044c',
    id_enrolled: '\u0417\u0430\u0447\u0438\u0441\u043b\u0435\u043d',
    id_school: '\u0428\u043a\u043e\u043b\u0430',
    id_valid: '\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u0430 \u0434\u043e',
    id_scan: '\u0421\u043a\u0430\u043d\u0438\u0440\u0443\u0439\u0442\u0435 \u0434\u043b\u044f \u043f\u0440\u043e\u0432\u0435\u0440\u043a\u0438',
    id_pending: '\u041a\u0430\u0440\u0442\u043e\u0447\u043a\u0430 \u043e\u0436\u0438\u0434\u0430\u0435\u0442 \u043e\u0434\u043e\u0431\u0440\u0435\u043d\u0438\u044f',
    admin_total_students: '\u0412\u0441\u0435\u0433\u043e \u0441\u0442\u0443\u0434\u0435\u043d\u0442\u043e\u0432',
    admin_active_tutors: '\u0410\u043a\u0442\u0438\u0432\u043d\u044b\u0445 \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u0435\u0439',
    admin_lessons_this_month: '\u0423\u0440\u043e\u043a\u043e\u0432 \u0432 \u044d\u0442\u043e\u043c \u043c\u0435\u0441\u044f\u0446\u0435',
    admin_revenue: '\u0414\u043e\u0445\u043e\u0434',
    admin_recent_registrations: '\u041f\u043e\u0441\u043b\u0435\u0434\u043d\u0438\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438',
    admin_pending_applications: '\u0417\u0430\u044f\u0432\u043a\u0438 \u043d\u0430 \u0440\u0430\u0441\u0441\u043c\u043e\u0442\u0440\u0435\u043d\u0438\u0438',
    admin_quick_actions: '\u0411\u044b\u0441\u0442\u0440\u044b\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f',
    admin_students_title: '\u0421\u0442\u0443\u0434\u0435\u043d\u0442\u044b',
    admin_student_name: '\u0418\u043c\u044f',
    admin_student_email: 'Email',
    admin_student_level: '\u0423\u0440\u043e\u0432\u0435\u043d\u044c',
    admin_student_joined: '\u0414\u0430\u0442\u0430 \u0432\u0441\u0442\u0443\u043f\u043b\u0435\u043d\u0438\u044f',
    admin_student_status: '\u0421\u0442\u0430\u0442\u0443\u0441',
    admin_student_lessons: '\u0423\u0440\u043e\u043a\u0438',
    admin_student_search: '\u041f\u043e\u0438\u0441\u043a \u0441\u0442\u0443\u0434\u0435\u043d\u0442\u043e\u0432...',
    admin_tutors_title: '\u041f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u0438',
    admin_tutor_applications: '\u0417\u0430\u044f\u0432\u043a\u0438',
    admin_tutor_active: '\u0410\u043a\u0442\u0438\u0432\u043d\u044b\u0435 \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u0438',
    admin_tutor_declined: '\u041e\u0442\u043a\u043b\u043e\u043d\u0451\u043d\u043d\u044b\u0435',
    admin_tutor_approve: '\u041e\u0434\u043e\u0431\u0440\u0438\u0442\u044c',
    admin_tutor_decline: '\u041e\u0442\u043a\u043b\u043e\u043d\u0438\u0442\u044c',
    admin_tutor_bio: '\u041e \u0441\u0435\u0431\u0435',
    admin_tutor_specializations: '\u0421\u043f\u0435\u0446\u0438\u0430\u043b\u0438\u0437\u0430\u0446\u0438\u0438',
    admin_tutor_applied: '\u041f\u043e\u0434\u0430\u043b \u0437\u0430\u044f\u0432\u043a\u0443',
    admin_tutor_no_applications: '\u041d\u0435\u0442 \u0437\u0430\u044f\u0432\u043e\u043a \u043d\u0430 \u0440\u0430\u0441\u0441\u043c\u043e\u0442\u0440\u0435\u043d\u0438\u0438',
    admin_tutor_no_active: '\u0410\u043a\u0442\u0438\u0432\u043d\u044b\u0445 \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u0435\u0439 \u043f\u043e\u043a\u0430 \u043d\u0435\u0442',
    admin_decline_reason: '\u041f\u0440\u0438\u0447\u0438\u043d\u0430 \u043e\u0442\u043a\u043b\u043e\u043d\u0435\u043d\u0438\u044f (\u043d\u0435\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e)',
    admin_decline_placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043f\u0440\u0438\u0447\u0438\u043d\u0443...',
    admin_settings_title: '\u041d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438 \u0448\u043a\u043e\u043b\u044b',
    admin_school_name: '\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u0448\u043a\u043e\u043b\u044b',
    admin_school_email: '\u041a\u043e\u043d\u0442\u0430\u043a\u0442\u043d\u044b\u0439 email',
    admin_school_phone: '\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430',
    admin_school_address: '\u0410\u0434\u0440\u0435\u0441',
    admin_school_city: '\u0413\u043e\u0440\u043e\u0434',
    admin_school_country: '\u0421\u0442\u0440\u0430\u043d\u0430',
    admin_features: '\u0424\u0443\u043d\u043a\u0446\u0438\u0438',
    admin_feature_ai: '\u0418\u0418-\u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u044c',
    admin_feature_homework: '\u0414\u043e\u043c\u0430\u0448\u043d\u0438\u0435 \u0437\u0430\u0434\u0430\u043d\u0438\u044f',
    admin_feature_certificates: '\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u044b',
    admin_feature_booking: '\u0417\u0430\u043f\u0438\u0441\u044c \u043a \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u044e',
    admin_save_settings: '\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438',
    admin_settings_saved: '\u041d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438 \u0443\u0441\u043f\u0435\u0448\u043d\u043e \u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u044b',
    admin_cert_title: '\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u044b',
    admin_cert_issue: '\u0412\u044b\u0434\u0430\u0442\u044c \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442',
    admin_cert_student: '\u0421\u0442\u0443\u0434\u0435\u043d\u0442',
    admin_cert_level: '\u0423\u0440\u043e\u0432\u0435\u043d\u044c',
    admin_cert_date: '\u0414\u0430\u0442\u0430 \u0432\u044b\u0434\u0430\u0447\u0438',
    admin_cert_actions: '\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044f',
    tutor_welcome: '\u0414\u043e\u0431\u0440\u043e \u043f\u043e\u0436\u0430\u043b\u043e\u0432\u0430\u0442\u044c',
    tutor_my_students: '\u041c\u043e\u0438 \u0441\u0442\u0443\u0434\u0435\u043d\u0442\u044b',
    tutor_sessions_today: '\u0417\u0430\u043d\u044f\u0442\u0438\u0439 \u0441\u0435\u0433\u043e\u0434\u043d\u044f',
    tutor_total_sessions: '\u0412\u0441\u0435\u0433\u043e \u0437\u0430\u043d\u044f\u0442\u0438\u0439',
    tutor_rating: '\u0420\u0435\u0439\u0442\u0438\u043d\u0433',
    tutor_earnings_title: '\u041c\u043e\u0439 \u0434\u043e\u0445\u043e\u0434',
    tutor_total_earned: '\u0412\u0441\u0435\u0433\u043e \u0437\u0430\u0440\u0430\u0431\u043e\u0442\u0430\u043d\u043e',
    tutor_this_month: '\u0412 \u044d\u0442\u043e\u043c \u043c\u0435\u0441\u044f\u0446\u0435',
    tutor_pending_payout: '\u041e\u0436\u0438\u0434\u0430\u0435\u0442 \u0432\u044b\u043f\u043b\u0430\u0442\u044b',
    tutor_payout_history: '\u0418\u0441\u0442\u043e\u0440\u0438\u044f \u0432\u044b\u043f\u043b\u0430\u0442',
    tutor_availability_title: '\u041c\u043e\u0451 \u0440\u0430\u0441\u043f\u0438\u0441\u0430\u043d\u0438\u0435',
    tutor_set_hours: '\u0423\u0441\u0442\u0430\u043d\u043e\u0432\u0438\u0442\u044c \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u044b\u0435 \u0447\u0430\u0441\u044b',
    tutor_id_card: '\u041c\u043e\u044f \u043a\u0430\u0440\u0442\u043e\u0447\u043a\u0430',
    tutor_id_number: 'ID \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u044f',
    tutor_approved: '\u041e\u0434\u043e\u0431\u0440\u0435\u043d',
    tutor_specializations: '\u0421\u043f\u0435\u0446\u0438\u0430\u043b\u0438\u0437\u0430\u0446\u0438\u0438',
    tutor_id_pending: '\u0412\u0430\u0448\u0430 \u043a\u0430\u0440\u0442\u043e\u0447\u043a\u0430 \u0431\u0443\u0434\u0435\u0442 \u0433\u043e\u0442\u043e\u0432\u0430 \u043f\u043e\u0441\u043b\u0435 \u043e\u0434\u043e\u0431\u0440\u0435\u043d\u0438\u044f',
    apply_title: '\u0421\u0442\u0430\u0442\u044c \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u0435\u043c',
    apply_step1: '\u041b\u0438\u0447\u043d\u044b\u0435 \u0434\u0430\u043d\u043d\u044b\u0435',
    apply_step2: '\u041e\u043f\u044b\u0442 \u0440\u0430\u0431\u043e\u0442\u044b',
    apply_step3: '\u041e\u0431\u0440\u0430\u0437\u043e\u0432\u0430\u043d\u0438\u0435',
    apply_step4: '\u041f\u0440\u043e\u0432\u0435\u0440\u043a\u0430',
    apply_first_name: '\u0418\u043c\u044f',
    apply_last_name: '\u0424\u0430\u043c\u0438\u043b\u0438\u044f',
    apply_email: 'Email',
    apply_password: '\u041f\u0430\u0440\u043e\u043b\u044c',
    apply_phone: '\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430',
    apply_dob: '\u0414\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f',
    apply_nationality: '\u0413\u0440\u0430\u0436\u0434\u0430\u043d\u0441\u0442\u0432\u043e',
    apply_native_lang: '\u0420\u043e\u0434\u043d\u043e\u0439 \u044f\u0437\u044b\u043a',
    apply_specializations: '\u0421\u043f\u0435\u0446\u0438\u0430\u043b\u0438\u0437\u0430\u0446\u0438\u0438',
    apply_bio: '\u041e \u0441\u0435\u0431\u0435',
    apply_bio_placeholder: '\u0420\u0430\u0441\u0441\u043a\u0430\u0436\u0438\u0442\u0435 \u043e \u0441\u0435\u0431\u0435 \u0438 \u0432\u0430\u0448\u0435\u043c \u043e\u043f\u044b\u0442\u0435 \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u043d\u0438\u044f...',
    apply_photo: '\u0424\u043e\u0442\u043e \u043f\u0440\u043e\u0444\u0438\u043b\u044f',
    apply_add_experience: '+ \u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043e\u043f\u044b\u0442',
    apply_job_title: '\u0414\u043e\u043b\u0436\u043d\u043e\u0441\u0442\u044c',
    apply_company: '\u041a\u043e\u043c\u043f\u0430\u043d\u0438\u044f / \u0428\u043a\u043e\u043b\u0430',
    apply_start_date: '\u0414\u0430\u0442\u0430 \u043d\u0430\u0447\u0430\u043b\u0430',
    apply_end_date: '\u0414\u0430\u0442\u0430 \u043e\u043a\u043e\u043d\u0447\u0430\u043d\u0438\u044f',
    apply_current: '\u0420\u0430\u0431\u043e\u0442\u0430\u044e \u0441\u0435\u0439\u0447\u0430\u0441',
    apply_description: '\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435',
    apply_degree: '\u0421\u0442\u0435\u043f\u0435\u043d\u044c',
    apply_institution: '\u0423\u0447\u0435\u0431\u043d\u043e\u0435 \u0437\u0430\u0432\u0435\u0434\u0435\u043d\u0438\u0435',
    apply_year: '\u0413\u043e\u0434',
    apply_certs: '\u041f\u0435\u0434\u0430\u0433\u043e\u0433\u0438\u0447\u0435\u0441\u043a\u0438\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u044b',
    apply_qual_upload: '\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u0435 \u043a\u0432\u0430\u043b\u0438\u0444\u0438\u043a\u0430\u0446\u0438\u0438',
    apply_cv_upload: '\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c \u0440\u0435\u0437\u044e\u043c\u0435 (\u043d\u0435\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e)',
    apply_submit: '\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u0437\u0430\u044f\u0432\u043a\u0443',
    apply_success_title: '\u0417\u0430\u044f\u0432\u043a\u0430 \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0430!',
    apply_success_msg: '\u041c\u044b \u0440\u0430\u0441\u0441\u043c\u043e\u0442\u0440\u0438\u043c \u0432\u0430\u0448\u0443 \u0437\u0430\u044f\u0432\u043a\u0443 \u0438 \u0441\u0432\u044f\u0436\u0435\u043c\u0441\u044f \u0441 \u0432\u0430\u043c\u0438 \u0432 \u0442\u0435\u0447\u0435\u043d\u0438\u0435 3-5 \u0440\u0430\u0431\u043e\u0447\u0438\u0445 \u0434\u043d\u0435\u0439.',
    school_hero_subtitle: '\u0418\u0437\u0443\u0447\u0430\u0439\u0442\u0435 \u0430\u043d\u0433\u043b\u0438\u0439\u0441\u043a\u0438\u0439 \u0441 \u043e\u043f\u044b\u0442\u043d\u044b\u043c\u0438 \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u044f\u043c\u0438 \u0438 \u0443\u0440\u043e\u043a\u0430\u043c\u0438 \u043d\u0430 \u043e\u0441\u043d\u043e\u0432\u0435 \u0418\u0418',
    school_enroll_now: '\u0417\u0430\u043f\u0438\u0441\u0430\u0442\u044c\u0441\u044f',
    school_learn_more: '\u0423\u0437\u043d\u0430\u0442\u044c \u0431\u043e\u043b\u044c\u0448\u0435',
    school_our_courses: '\u041d\u0430\u0448\u0438 \u043a\u0443\u0440\u0441\u044b',
    school_all_levels: '\u0412\u0441\u0435 \u0443\u0440\u043e\u0432\u043d\u0438',
    school_beginner: '\u041d\u0430\u0447\u0438\u043d\u0430\u044e\u0449\u0438\u0439',
    school_intermediate: '\u0421\u0440\u0435\u0434\u043d\u0438\u0439',
    school_advanced: '\u041f\u0440\u043e\u0434\u0432\u0438\u043d\u0443\u0442\u044b\u0439',
    school_our_tutors: '\u041d\u0430\u0448\u0438 \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u0438',
    school_contact: '\u0421\u0432\u044f\u0437\u0430\u0442\u044c\u0441\u044f \u0441 \u043d\u0430\u043c\u0438',
    school_location: '\u0410\u0434\u0440\u0435\u0441',
    school_phone: '\u0422\u0435\u043b\u0435\u0444\u043e\u043d',
    school_email: 'Email',
    school_get_in_touch: '\u041d\u0430\u043f\u0438\u0441\u0430\u0442\u044c \u043d\u0430\u043c',
    school_your_name: '\u0412\u0430\u0448\u0435 \u0438\u043c\u044f',
    school_your_email: '\u0412\u0430\u0448 email',
    school_your_message: '\u0412\u0430\u0448\u0435 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435',
    school_send_message: '\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c',
    school_login_student: '\u0412\u0445\u043e\u0434 \u0434\u043b\u044f \u0441\u0442\u0443\u0434\u0435\u043d\u0442\u043e\u0432',
    school_login_tutor: '\u0412\u0445\u043e\u0434 \u0434\u043b\u044f \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u0435\u0439',
    school_apply_tutor: '\u0421\u0442\u0430\u0442\u044c \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u0435\u043c',
    school_powered_by: '\u0420\u0430\u0431\u043e\u0442\u0430\u0435\u0442 \u043d\u0430 SpeakIQ',
    school_why_us: '\u041f\u043e\u0447\u0435\u043c\u0443 \u0432\u044b\u0431\u0438\u0440\u0430\u044e\u0442 \u043d\u0430\u0441?',
    school_ai_powered: '\u041e\u0431\u0443\u0447\u0435\u043d\u0438\u0435 \u0441 \u0418\u0418',
    school_ai_desc: '\u041f\u0435\u0440\u0441\u043e\u043d\u0430\u043b\u0438\u0437\u0438\u0440\u043e\u0432\u0430\u043d\u043d\u044b\u0435 \u0443\u0440\u043e\u043a\u0438, \u0430\u0434\u0430\u043f\u0442\u0438\u0440\u043e\u0432\u0430\u043d\u043d\u044b\u0435 \u043a \u0432\u0430\u0448\u0435\u043c\u0443 \u0443\u0440\u043e\u0432\u043d\u044e',
    school_expert_tutors: '\u041e\u043f\u044b\u0442\u043d\u044b\u0435 \u043f\u0440\u0435\u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0435\u043b\u0438',
    school_tutors_desc: '\u041a\u0432\u0430\u043b\u0438\u0444\u0438\u0446\u0438\u0440\u043e\u0432\u0430\u043d\u043d\u044b\u0435 \u0443\u0447\u0438\u0442\u0435\u043b\u044f \u0441 \u043c\u043d\u043e\u0433\u043e\u043b\u0435\u0442\u043d\u0438\u043c \u043e\u043f\u044b\u0442\u043e\u043c',
    school_certificates: '\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u044b',
    school_cert_desc: '\u041f\u043e\u043b\u0443\u0447\u0430\u0439\u0442\u0435 \u043c\u0435\u0436\u0434\u0443\u043d\u0430\u0440\u043e\u0434\u043d\u043e \u043f\u0440\u0438\u0437\u043d\u0430\u043d\u043d\u044b\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u044b CEFR',
    school_flexible: '\u0413\u0438\u0431\u043a\u0438\u0439 \u0433\u0440\u0430\u0444\u0438\u043a',
    school_flex_desc: '\u0423\u0447\u0438\u0442\u0435\u0441\u044c \u0432 \u0441\u0432\u043e\u0451\u043c \u0442\u0435\u043c\u043f\u0435 \u0432 \u043b\u044e\u0431\u043e\u0435 \u0432\u0440\u0435\u043c\u044f',
    level_a1: '\u041d\u0430\u0447\u0438\u043d\u0430\u044e\u0449\u0438\u0439 (A1)',
    level_a2: '\u042d\u043b\u0435\u043c\u0435\u043d\u0442\u0430\u0440\u043d\u044b\u0439 (A2)',
    level_b1: '\u0421\u0440\u0435\u0434\u043d\u0438\u0439 (B1)',
    level_b2: '\u0412\u044b\u0448\u0435 \u0441\u0440\u0435\u0434\u043d\u0435\u0433\u043e (B2)',
    level_c1: '\u041f\u0440\u043e\u0434\u0432\u0438\u043d\u0443\u0442\u044b\u0439 (C1)',
    level_c2: '\u0412 \u0441\u043e\u0432\u0435\u0440\u0448\u0435\u043d\u0441\u0442\u0432\u0435 (C2)',
    err_required: '\u042d\u0442\u043e \u043f\u043e\u043b\u0435 \u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e',
    err_invalid_email: '\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0439 \u043f\u043e\u0447\u0442\u044b',
    err_server: '\u041e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430. \u041f\u043e\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0441\u043d\u043e\u0432\u0430.',
    err_network: '\u041e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0442\u0438. \u041f\u0440\u043e\u0432\u0435\u0440\u044c\u0442\u0435 \u043f\u043e\u0434\u043a\u043b\u044e\u0447\u0435\u043d\u0438\u0435.',
    err_unauthorized: '\u0423 \u0432\u0430\u0441 \u043d\u0435\u0442 \u0434\u043e\u0441\u0442\u0443\u043f\u0430 \u043a \u044d\u0442\u043e\u0439 \u0441\u0442\u0440\u0430\u043d\u0438\u0446\u0435',
    err_not_found: '\u0421\u0442\u0440\u0430\u043d\u0438\u0446\u0430 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u0430',

    // Payment system
    pay_title: 'Оплата курса',
    pay_pending: 'Требуется оплата',
    pay_pending_desc: 'Чтобы получить доступ к курсу, пожалуйста оплатите банковским переводом.',
    pay_submitted: 'Ожидание подтверждения',
    pay_submitted_desc: 'Доказательство оплаты получено. Мы скоро подтвердим ваш платёж.',
    pay_confirmed: 'Оплата подтверждена',
    pay_confirmed_desc: 'Ваш курс открыт. Добро пожаловать!',
    pay_upload_proof: 'Загрузить доказательство',
    pay_uploading: 'Загрузка...',
    pay_upload_done: 'Документ загружен',
    pay_bank_name: 'Название банка',
    pay_account_holder: 'Владелец счёта',
    pay_account_number: 'Номер счёта',
    pay_sort_code: 'Сортировочный код',
    pay_swift: 'SWIFT / BIC',
    pay_paypal: 'Email PayPal',
    pay_wise: 'Email Wise',
    pay_notes: 'Примечания к оплате',
    // Greetings
    dash_good_morning: 'Доброе утро',
    dash_good_afternoon: 'Добрый день',
    dash_good_evening: 'Добрый вечер',
  },

  uz: {
    nav_overview: "Umumiy ko'rinish",
    nav_students: 'Talabalar',
    nav_tutors: "O'qituvchilar",
    nav_payments: "To'lovlar",
    nav_branding: 'Brendlash',
    nav_bookings: 'Bronlar',
    nav_supply_demand: 'Talab va taklif',
    nav_marketing: 'Marketing',
    nav_settings: 'Sozlamalar',
    nav_pricing: 'Narxlar',
    nav_certificates: 'Sertifikatlar',
    nav_website: 'Vebsayt',
    nav_registrations: "Ro'yxatga olish",
    nav_logout: 'Chiqish',
    nav_partner_panel: 'Hamkor paneli',
    nav_dashboard: 'Bosh sahifa',
    nav_my_lessons: 'Mening darslarim',
    nav_placement_test: 'Daraja testi',
    nav_vocabulary: "Lug'at",
    nav_my_certificates: 'Mening sertifikatlarim',
    nav_book_tutor: "O'qituvchi bron qilish",
    nav_homework: 'Uy vazifasi',
    nav_my_id: 'Mening kartam',
    nav_payment_settings: "To'lov sozlamalari",
    nav_payouts: "To'lovlar",
    nav_programmes: 'Dasturlar',
    nav_my_students: 'Mening talabalarim',
    nav_earnings: 'Mening daromadim',
    nav_availability: 'Jadval',
    nav_my_id_card: 'Mening kartam',
    btn_save: 'Saqlash',
    btn_cancel: 'Bekor qilish',
    btn_submit: 'Yuborish',
    btn_delete: "O'chirish",
    btn_edit: 'Tahrirlash',
    btn_add: "Qo'shish",
    btn_search: 'Qidirish',
    btn_filter: 'Filtr',
    btn_export: 'Eksport',
    btn_back: 'Orqaga',
    btn_next: 'Keyingi',
    btn_previous: 'Oldingi',
    btn_confirm: 'Tasdiqlash',
    btn_close: 'Yopish',
    btn_upload: 'Yuklash',
    btn_download: 'Yuklab olish',
    btn_approve: 'Tasdiqlash',
    btn_decline: 'Rad etish',
    btn_view: "Ko'rish",
    btn_apply: 'Ariza berish',
    btn_login: 'Kirish',
    btn_register: "Ro'yxatdan o'tish",
    btn_logout: 'Chiqish',
    btn_send: 'Yuborish',
    btn_start: 'Boshlash',
    btn_finish: 'Tugatish',
    btn_continue: 'Davom etish',
    btn_try_again: 'Qayta urinish',
    btn_get_started: 'Boshlash',
    btn_learn_more: "Ko'proq bilish",
    status_active: 'Faol',
    status_inactive: 'Faol emas',
    status_pending: "Ko'rib chiqilmoqda",
    status_approved: 'Tasdiqlangan',
    status_declined: 'Rad etilgan',
    status_suspended: "To'xtatilgan",
    status_trial: 'Sinov',
    status_loading: 'Yuklanmoqda...',
    status_error: 'Xatolik yuz berdi',
    status_success: 'Muvaffaqiyatli',
    status_no_data: "Ma'lumot topilmadi",
    status_saved: 'Saqlandi!',
    login_title: 'Xush kelibsiz',
    login_subtitle: 'Hisobingizga kiring',
    login_email: 'Elektron pochta',
    login_password: 'Parol',
    login_forgot: 'Parolni unutdingizmi?',
    login_no_account: "Hisobingiz yo'qmi?",
    login_sign_up: "Ro'yxatdan o'ting",
    login_error: "Noto'g'ri email yoki parol",
    login_loading: 'Kirish...',
    login_partner_title: 'Hamkor administrator portali',
    login_student_title: 'Talaba portali',
    login_tutor_title: "O'qituvchi portali",
    login_apply_tutor: "O'qituvchi bo'lish \u2192",
    register_title: 'Hisob yaratish',
    register_first_name: 'Ism',
    register_last_name: 'Familiya',
    register_email: 'Elektron pochta',
    register_password: 'Parol',
    register_confirm_password: 'Parolni tasdiqlash',
    register_phone: 'Telefon raqami',
    register_submit: 'Hisob yaratish',
    register_have_account: 'Hisobingiz bormi?',
    register_sign_in: 'Kirish',
    register_success: 'Hisob yaratildi! Pochtangizni tekshiring.',
    register_error_match: "Parollar mos kelmaydi",
    register_error_exists: "Bu email allaqachon ro'yxatdan o'tgan",
    dash_welcome: 'Xush kelibsiz',
    dash_current_level: 'Joriy daraja',
    dash_lessons_completed: 'Tugatilgan darslar',
    dash_avg_score: "O'rtacha ball",
    dash_streak: 'kun ketma-ket',
    dash_continue_learning: "O'qishni davom ettirish",
    dash_recent_activity: "So'nggi faollik",
    dash_my_progress: 'Mening rivojlanishim',
    dash_upcoming: 'Kelgusi',
    dash_achievements: 'Yutuqlar',
    dash_start_lesson: 'Darsni boshlash',
    dash_take_test: 'Daraja testini topshirish',
    dash_no_level: 'Daraja hali belgilanmagan',
    dash_complete_placement: 'Boshlash uchun daraja testini topshiring',
    lesson_title: 'Dars',
    lesson_question: 'Savol',
    lesson_of: 'dan',
    lesson_check: 'Javobni tekshirish',
    lesson_next: 'Keyingi savol',
    lesson_correct: "To'g'ri!",
    lesson_incorrect: "Noto'g'ri",
    lesson_complete: 'Dars tugadi!',
    lesson_score: 'Sizning natijangiz',
    lesson_ask_question: "Dars bo'yicha savol bering",
    lesson_type_question: 'Savolingizni kiriting...',
    lesson_grammar: 'Grammatika',
    lesson_vocabulary: "Lug'at",
    lesson_reading: "O'qish",
    lesson_writing: 'Yozish',
    lesson_conversation: 'Suhbat',
    lesson_ielts: 'IELTS tayyorgarligi',
    lesson_business: 'Biznes ingliz tili',
    lesson_questions_remaining: 'bepul savol qoldi',
    lesson_well_done: 'Ajoyib!',
    lesson_keep_going: 'Davom eting!',
    lesson_try_harder: 'Mashq qiling!',
    placement_title: 'Ingliz tili darajasi testi',
    placement_subtitle: 'Biz sizning darajangizni aniqlaymiz',
    placement_start: 'Testni boshlash',
    placement_question: 'Savol',
    placement_complete: 'Test tugadi',
    placement_your_level: 'Sizning ingliz tili darajangiz',
    placement_result_msg: "Javoblaringizga ko'ra, sizning darajangiz",
    placement_retake: 'Qayta topshirish',
    vocab_title: "Lug'at banki",
    vocab_search: "So'z qidirish...",
    vocab_add: "So'z qo'shish",
    vocab_word: "So'z",
    vocab_definition: "Ta'rif",
    vocab_example: 'Misol',
    vocab_level: 'Daraja',
    vocab_empty: 'Hali so\'z saqlanmagan',
    vocab_add_first: "Darslardan so'z qo'shishni boshlang",
    cert_title: 'Mening sertifikatlarim',
    cert_level: 'Daraja',
    cert_issued: 'Berilgan',
    cert_download: 'PDF yuklab olish',
    cert_verify: 'Tekshirish',
    cert_empty: 'Hali sertifikat yo\'q',
    cert_complete_msg: 'Sertifikat olish uchun darajani bajaring',
    cert_achievement: 'Tugatish sertifikati',
    book_title: "O'qituvchi bron qilish",
    book_select_tutor: "O'qituvchi tanlash",
    book_select_time: 'Vaqt tanlash',
    book_confirm: 'Bronni tasdiqlash',
    book_success: 'Bron tasdiqlandi!',
    book_no_tutors: "O'qituvchilar mavjud emas",
    book_specialization: 'Ixtisoslik',
    book_rate: 'Narx',
    book_per_hour: 'soatiga',
    book_available: 'Mavjud',
    hw_title: 'Uy vazifasi',
    hw_due: 'Muddat',
    hw_submit: 'Uy vazifasini topshirish',
    hw_submitted: 'Topshirildi',
    hw_pending: 'Kutilmoqda',
    hw_overdue: "Muddati o'tgan",
    hw_grade: 'Baho',
    hw_feedback: 'Fikr-mulohaza',
    hw_empty: 'Uy vazifasi yo\'q',
    hw_instructions: "Ko'rsatmalar",
    hw_your_answer: 'Sizning javobingiz',
    hw_word_count: "so'z",
    id_title: 'Mening kartam',
    id_student: 'Talaba',
    id_level: 'Daraja',
    id_enrolled: 'Qabul qilingan',
    id_school: 'Maktab',
    id_valid: 'Amal qilish muddati',
    id_scan: 'Tekshirish uchun skanlang',
    id_pending: 'Karta tasdiqlanishini kutmoqda',
    admin_total_students: 'Jami talabalar',
    admin_active_tutors: "Faol o'qituvchilar",
    admin_lessons_this_month: 'Bu oyda darslar',
    admin_revenue: 'Daromad',
    admin_recent_registrations: "So'nggi ro'yxatga olishlar",
    admin_pending_applications: "Ko'rib chiqilayotgan arizalar",
    admin_quick_actions: 'Tezkor amallar',
    admin_students_title: 'Talabalar',
    admin_student_name: 'Ism',
    admin_student_email: 'Email',
    admin_student_level: 'Daraja',
    admin_student_joined: "Qo'shilgan sana",
    admin_student_status: 'Holat',
    admin_student_lessons: 'Darslar',
    admin_student_search: 'Talabalarni qidirish...',
    admin_tutors_title: "O'qituvchilar",
    admin_tutor_applications: 'Arizalar',
    admin_tutor_active: "Faol o'qituvchilar",
    admin_tutor_declined: 'Rad etilganlar',
    admin_tutor_approve: 'Tasdiqlash',
    admin_tutor_decline: 'Rad etish',
    admin_tutor_bio: "O'zi haqida",
    admin_tutor_specializations: 'Ixtisosliklar',
    admin_tutor_applied: 'Ariza bergan',
    admin_tutor_no_applications: "Ko'rib chiqilayotgan arizalar yo'q",
    admin_tutor_no_active: "Hali faol o'qituvchilar yo'q",
    admin_decline_reason: 'Rad etish sababi (ixtiyoriy)',
    admin_decline_placeholder: 'Sababni kiriting...',
    admin_settings_title: 'Maktab sozlamalari',
    admin_school_name: 'Maktab nomi',
    admin_school_email: 'Aloqa email',
    admin_school_phone: 'Telefon raqami',
    admin_school_address: 'Manzil',
    admin_school_city: 'Shahar',
    admin_school_country: 'Mamlakat',
    admin_features: 'Xususiyatlar',
    admin_feature_ai: "AI o'qituvchi",
    admin_feature_homework: 'Uy vazifalari',
    admin_feature_certificates: 'Sertifikatlar',
    admin_feature_booking: "O'qituvchi bron qilish",
    admin_save_settings: 'Sozlamalarni saqlash',
    admin_settings_saved: 'Sozlamalar muvaffaqiyatli saqlandi',
    admin_cert_title: 'Sertifikatlar',
    admin_cert_issue: 'Sertifikat berish',
    admin_cert_student: 'Talaba',
    admin_cert_level: 'Daraja',
    admin_cert_date: 'Berilgan sana',
    admin_cert_actions: 'Amallar',
    tutor_welcome: 'Xush kelibsiz',
    tutor_my_students: 'Mening talabalarim',
    tutor_sessions_today: "Bugungi mashg'ulotlar",
    tutor_total_sessions: "Jami mashg'ulotlar",
    tutor_rating: 'Reyting',
    tutor_earnings_title: 'Mening daromadim',
    tutor_total_earned: 'Jami ishlangan',
    tutor_this_month: 'Bu oyda',
    tutor_pending_payout: "To'lov kutilmoqda",
    tutor_payout_history: "To'lov tarixi",
    tutor_availability_title: 'Mening jadvalim',
    tutor_set_hours: 'Mavjud soatlarni belgilash',
    tutor_id_card: 'Mening kartam',
    tutor_id_number: "O'qituvchi ID",
    tutor_approved: 'Tasdiqlangan',
    tutor_specializations: 'Ixtisosliklar',
    tutor_id_pending: 'Kartangiz tasdiqlanganidan keyin tayyor bo\'ladi',
    apply_title: "O'qituvchi bo'lish",
    apply_step1: "Shaxsiy ma'lumotlar",
    apply_step2: 'Ish tajribasi',
    apply_step3: "Ta'lim",
    apply_step4: "Ko'rib chiqish",
    apply_first_name: 'Ism',
    apply_last_name: 'Familiya',
    apply_email: 'Email',
    apply_password: 'Parol',
    apply_phone: 'Telefon raqami',
    apply_dob: "Tug'ilgan sana",
    apply_nationality: 'Fuqarolik',
    apply_native_lang: 'Ona tili',
    apply_specializations: 'Ixtisosliklar',
    apply_bio: "O'zingiz haqingizda",
    apply_bio_placeholder: "O'zingiz va o'qitish tajribangiz haqida gapiring...",
    apply_photo: 'Profil rasmi',
    apply_add_experience: "+ Tajriba qo'shish",
    apply_job_title: 'Lavozim',
    apply_company: 'Kompaniya / Maktab',
    apply_start_date: 'Boshlanish sanasi',
    apply_end_date: 'Tugash sanasi',
    apply_current: 'Hozir ishlayapman',
    apply_description: 'Tavsif',
    apply_degree: 'Daraja',
    apply_institution: "Ta'lim muassasasi",
    apply_year: 'Yil',
    apply_certs: "O'qituvchilik sertifikatlari",
    apply_qual_upload: 'Malaka tasdiqini yuklash',
    apply_cv_upload: 'CV yuklash (ixtiyoriy)',
    apply_submit: 'Ariza yuborish',
    apply_success_title: 'Ariza yuborildi!',
    apply_success_msg: 'Biz arizangizni ko\'rib chiqamiz va 3-5 ish kuni ichida siz bilan bog\'lanamiz.',
    school_hero_subtitle: "Mutaxassis o'qituvchilar va AI darslari bilan ingliz tilini o'rganing",
    school_enroll_now: "Ro'yxatdan o'tish",
    school_learn_more: "Ko'proq bilish",
    school_our_courses: 'Bizning kurslar',
    school_all_levels: 'Barcha darajalar',
    school_beginner: "Boshlang'ich",
    school_intermediate: "O'rta",
    school_advanced: 'Yuqori',
    school_our_tutors: "Bizning o'qituvchilar",
    school_contact: 'Biz bilan bog\'laning',
    school_location: 'Manzil',
    school_phone: 'Telefon',
    school_email: 'Email',
    school_get_in_touch: 'Murojaat qiling',
    school_your_name: 'Ismingiz',
    school_your_email: 'Emailingiz',
    school_your_message: 'Xabaringiz',
    school_send_message: 'Yuborish',
    school_login_student: 'Talabalar kirishi',
    school_login_tutor: "O'qituvchilar kirishi",
    school_apply_tutor: "O'qituvchi bo'lish",
    school_powered_by: 'SpeakIQ tomonidan',
    school_why_us: 'Nima uchun bizni tanlashadi?',
    school_ai_powered: 'AI bilan o\'qish',
    school_ai_desc: 'Darajangizga moslashtirilgan shaxsiy darslar',
    school_expert_tutors: "Mutaxassis o'qituvchilar",
    school_tutors_desc: "Ko'p yillik tajribaga ega malakali o'qituvchilar",
    school_certificates: 'Sertifikatlar',
    school_cert_desc: 'Xalqaro tan olingan CEFR sertifikatlarini oling',
    school_flexible: 'Moslashuvchan jadval',
    school_flex_desc: "Istalgan vaqtda o'z sur'atingizda o'rganing",
    level_a1: "Boshlang'ich (A1)",
    level_a2: 'Elementar (A2)',
    level_b1: "O'rta (B1)",
    level_b2: "O'rta yuqori (B2)",
    level_c1: "Ilg'or (C1)",
    level_c2: 'Mukammal (C2)',
    err_required: 'Bu maydon majburiy',
    err_invalid_email: "Noto'g'ri elektron pochta manzili",
    err_server: 'Server xatosi. Qayta urinib ko\'ring.',
    err_network: 'Tarmoq xatosi. Ulanishingizni tekshiring.',
    err_unauthorized: "Bu sahifani ko'rishga ruxsatingiz yo'q",
    err_not_found: 'Sahifa topilmadi',

    // Payment system
    pay_title: "Kurs to'lovi",
    pay_pending: "To'lov talab etiladi",
    pay_pending_desc: "Kursga kirish uchun bank o'tkazmasi qiling va to'lov isbotini yuklang.",
    pay_submitted: "Tasdiqlash kutilmoqda",
    pay_submitted_desc: "To'lov isbotingiz qabul qilindi. Tez orada tasdiqlaymiz.",
    pay_confirmed: "To'lov tasdiqlandi",
    pay_confirmed_desc: "Kurs ochildi. Xush kelibsiz!",
    pay_upload_proof: "To'lov isbotini yuklash",
    pay_uploading: "Yuklanmoqda...",
    pay_upload_done: "Hujjat yuklandi",
    pay_bank_name: "Bank nomi",
    pay_account_holder: "Hisob egasi",
    pay_account_number: "Hisob raqami",
    pay_sort_code: "Sort kodi",
    pay_swift: "SWIFT / BIC",
    pay_paypal: "PayPal Email",
    pay_wise: "Wise Email",
    pay_notes: "To'lov izohlari",
    // Greetings
    dash_good_morning: 'Xayrli tong',
    dash_good_afternoon: 'Xayrli kun',
    dash_good_evening: 'Xayrli kech',
  },
};

export default translations;
